import WorkStatus from '@/dossier/constants/WorkStatus';
import PriceApprovalStatus from '../constants/PriceApprovalStatus';

export function getWorkStatusIcon(status: WorkStatus): string {
  switch (status) {
    case WorkStatus.BEING_HANDLED:
      return 'play';
    case WorkStatus.ON_HOLD:
      return 'pause';
    case WorkStatus.WORK_READY:
      return 'stop';
    default:
      return 'empty';
  }
}

export function getPriceApprovalStatusIcon(status: PriceApprovalStatus): string {
  switch (status) {
    case PriceApprovalStatus.NOT_GIVEN:
      return 'minus-double';
    case PriceApprovalStatus.APPROVED:
      return 'thumbs-up';
    case PriceApprovalStatus.REFUSED:
      return 'thumbs-down';
  }
}
